import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class TableUtilsService {

	/**
	 * Détermine s'il faut afficher le dropdown raccourci pour naviguer entre les pages.
	 *
	 * @param valeurs les valeurs du tableau.
	 * @param valeursFiltrees les valeurs filtrees du tableau.
	 * @param nombreLigneParPage le nombre de ligne par page parametre.
	 */
	afficherRaccourciPage<T>(valeurs: T[], valeursFiltrees: T[], nombreLigneParPage: number): boolean {
		const nombreMinimumLignesPourAfficher = 5 * nombreLigneParPage; // 5 pages * nombre de lignes par page

		const nombreDeLignes = !!valeursFiltrees
			? valeursFiltrees?.length
			: valeurs?.length;

		return (nombreDeLignes || 0) > nombreMinimumLignesPourAfficher;
	}

}
